export default __webpack_public_path__ + "static/media/a037-student-t3-9.02f71750.svg";